// src/pages/HomePage.jsx

import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import CategoryList from "../components/home/categoryList";
import PastArticlesByYear from "../components/home/PastArticlesByYear";
import LatestArticles from "../components/home/LatestArticles";
import CommentSection from "../modules/Chat/CommentSection";
import { getAuth, signInAnonymously } from "firebase/auth";
import "./LibraryPage.css";
import AffiliateLinks from "./../modules/amazonAffiliate/AffiliateLinks";

const HomePage = () => {
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    const auth = getAuth();
    signInAnonymously(auth)
      .then((res) => {
        setUserId(res.user.uid);
      })
      .catch((err) => {
        console.error("匿名ログイン失敗:", err);
      });
  }, []);

  return (
    <div className="home-container">
      <div className="home-header">
        <h1 className="main-catch">
          みんなの話が
          <br />
          一本の大きな木になる
        </h1>
        <p className="sub-catch">
          Mind Threatは
          <br />
          アイデアを出し合えるスレッドサイトです。
        </p>
      </div>

      <div className="home-sections">
        {/* 左カラム：カテゴリ */}
        <div className="home-box">
          <div className="scroll-box">
            <h2>カテゴリ検索</h2>
            <CategoryList />
          </div>
        </div>

        {/* 中央カラム：メイン */}
        <div className="home-box main">
          <div className="home-section button-group">
            <Link to="/create">
              <button className="main-button">新規スレッド作成</button>
            </Link>
            <Link to="/library">
              <button className="main-button">図書館ページ</button>
            </Link>
          </div>

          <div className="affiliate-group home-section">
            {/* 🔹 AffiliateLinks を表示 */}
            <AffiliateLinks />
          </div>

          <div className="latest-group home-section">
            <LatestArticles />
          </div>

          <div className="comment-group home-section comment-section">
            <p>▼サイトへのご意見等をお聞かせください</p>
            
            {userId && <CommentSection nodeId="homePage" userId={userId} />}
          </div>
        </div>

        {/* 右カラム：過去記事 */}
        <div className="home-box">
          <div className="scroll-box">
            <h2>過去記事</h2>
            <PastArticlesByYear />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
